import React from 'react'

export const ClockIcon = () => {
  return (
    <svg
      width='15'
      height='18'
      viewBox='0 0 15 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0062 10.4734L7.04688 8.70819V4.90356'
        stroke='#141414'
        strokeWidth='0.901855'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.0421 4.24211C13.1552 6.35529 13.1552 9.78143 11.0421 11.8946C8.92888 14.0078 5.50274 14.0078 3.38957 11.8946C1.27639 9.78142 1.27639 6.35528 3.38957 4.24211C5.50275 2.12893 8.92889 2.12893 11.0421 4.24211'
        stroke='#141414'
        strokeWidth='0.901855'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
